// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__gGEF_","buttons":"RemoveExpirationActionButtons_buttons__Sic2X"};